module.exports = __webpack_public_path__ + "img/rs.30209ab6.svg";